export enum CheckoutSteps {
    FormaRecebimento = 0,
    ConfirmarDados = 1,
    FormaPagamento = 2,
    Concluido = 3,
}
